import { Amplify } from "aws-amplify";
import {
  signIn,
  signOut,
  confirmSignIn,
  fetchAuthSession,
  updatePassword,
} from "aws-amplify/auth";

import {
  setTokenInterceptor,
  resetTokenInterceptor,
} from "./axios-interceptor";

import { getServiceVersion } from "../api/serviceVersion";

import { loginUserDifine } from "./store";
import { CONST } from "../config/const";

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: CONST.userPoolId,
      userPoolClientId: CONST.userPoolClientId,
    },
  },
});

export async function fetchAuth() {
  const session = await fetchAuthSession();
  if (session.tokens && session.tokens.idToken) {
    await resetTokenInterceptor();
    const idToken = session.tokens.idToken.toString();
    await setTokenInterceptor(idToken, true);
    const loginUser: loginUserDifine = {
      idToken: idToken,
      username: "",
      authority: session.tokens.idToken.payload["custom:authority"] as string,
      db_authority: "",
      company: session.tokens.idToken.payload["custom:company"] as string,
      title: session.tokens.idToken.payload["custom:title"] as string,
      color: session.tokens.idToken.payload["custom:color"] as string,
    };
    const documentTitle = session.tokens.idToken.payload[
      "custom:title"
    ] as string;
    document.title = documentTitle;

    return { login: true, loginUser };
  } else {
    return { login: false };
  }
}

export async function checkAuth() {
  let serviceVersion = await getServiceVersion();
  if (serviceVersion === "error") {
    const session = await fetchAuthSession({ forceRefresh: true });
    if (session.tokens && session.tokens.idToken) {
      await resetTokenInterceptor();
      const idToken = session.tokens.idToken.toString();
      await setTokenInterceptor(idToken, false);
      serviceVersion = await getServiceVersion();
      if (serviceVersion === "error") {
        logout();
      }
    } else {
      logout();
    }
  }
  return serviceVersion;
}

//ユーザーネームとパスワードでのログイン
export async function handleClickSignIn(loginId: string, password: string) {
  try {
    const { isSignedIn, nextStep } = await signIn({
      username: loginId,
      password,
    });
    if (isSignedIn) {
      return "Login";
    }
    return "NextStep";
  } catch (error) {
    return "Error";
  }
}

//ユーザーネームとパスワードでのログイン
export async function handleClickConfirmSignIn(newPassword: string) {
  try {
    const { isSignedIn, nextStep } = await confirmSignIn({
      challengeResponse: newPassword,
      options: {
        ChallengeName: "NEW_PASSWORD_REQUIRED",
      },
    });
    if (isSignedIn) {
      return "Login";
    }
    return "NextStep";
  } catch (error) {
    return "Error";
  }
}

// パスワード変更
export async function handleUpdatePassword({
  oldPassword,
  newPassword,
}: {
  oldPassword: string;
  newPassword: string;
}) {
  try {
    await updatePassword({ oldPassword, newPassword });
    return "success";
  } catch (err) {
    if (err instanceof Error) {
      const err_message = err.message || err.toString();
      if (err_message.indexOf("Password did not conform with policy") > -1) {
        return "NotPolicy";
      } else if (err_message.indexOf("Incorrect username or password") > -1) {
        return "Incorrect";
      } else if (
        err_message.indexOf(
          "Attempt limit exceeded, please try after some time",
        ) > -1
      ) {
        return "LimitExceeded";
      }
    }
    return "failed";
  }
}

// ログアウト
export function logout() {
  signOut({ global: true }).then(() => {
    window.location.reload();
  });
}
